import React from "react";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const ActivityLink = ({to, children, className = "", title}) => {
    const navigate = navigateHook();
    const content = children ?? "";

    if (!to) return <span>{content}</span>;

    const onClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        navigate(to.dev, true);
    };

    return (
        <button
            type="button"
            className={["a-link", className].filter(Boolean).join(" ")}
            title={title}
            onClick={onClick}
        >
            {content}
        </button>
    );
};

export default ActivityLink;
